import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { CURRENT_VERSION } from '../../config/version';
import './Settings.scss';

const Settings = () => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="settings-page">
        <div className="settings-container">
          <div className="loading">Loading...</div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="settings-page">
      <div className="settings-container">
        <div className="settings-header">
          <h1>Settings</h1>
          <p>Manage your account preferences</p>
        </div>

        <div className="settings-content">
          <div className="settings-section">
            <h2>Account Settings</h2>
            <div className="settings-item">
              <label>Username</label>
              <div className="setting-value">
                {user.username}
              </div>
            </div>
            <div className="settings-item">
              <label>Email</label>
              <div className="setting-value">
                {user.email}
              </div>
            </div>
          </div>

          <div className="settings-section">
            <h2>About</h2>
            <div className="settings-item">
              <label>Version</label>
              <div className="setting-value">Guess Nexus v{CURRENT_VERSION}</div>
            </div>
            <div className="settings-item">
              <label>Member Since</label>
              <div className="setting-value">
                {new Date(user.created_at).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;